import { render, staticRenderFns } from "./RoleHeader.vue?vue&type=template&id=a258cb38&scoped=true"
import script from "./RoleHeader.vue?vue&type=script&lang=js"
export * from "./RoleHeader.vue?vue&type=script&lang=js"
import style0 from "./RoleHeader.vue?vue&type=style&index=0&id=a258cb38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a258cb38",
  null
  
)

export default component.exports